import { motion } from "framer-motion";
import { ComponentProps, useEffect, useState } from "react";
import Confetti from "react-dom-confetti";
import { useNavigate } from "react-router-dom";
import Button from "src/components/Button";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import useBoards from "src/hooks/api/services/tasks/useBoards";
import useTenant from "src/hooks/api/services/tenants/useTenant";
import useTeams from "src/hooks/api/services/users/useTeams";
import useUsers from "src/hooks/api/services/users/useUsers";
import useFetchProfile from "src/hooks/api/useFetchProfile";
import useAuth from "src/hooks/selectors/useAuth";
import { cn } from "src/lib/utils";

const Completed = ({
	t,
	children,
	className,
	...rest
}: Translation & ComponentProps<"div">) => {
	const auth = useAuth();
	const { tenant, taskType } = useTenant();
	const { fetchProfile } = useFetchProfile();
	const users = useUsers();
	const boards = useBoards();
	const teams = useTeams();
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(false);
	const [showConfetti] = useState(false);

	useEffect(() => {
		if (
			auth.type === "company" &&
			!auth?.company?.subscription &&
			["getrecruitmentdone", "getjobsdone", "getcrewdone"].includes(
				tenant.slug
			)
		) {
			navigate("/subscription");
		} else {
			navigate("/dashboard");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleSubmit = async () => {
		setIsLoading(true);
		await Promise.all([
			users.actions.list(),
			boards.actions.list(),
			teams.actions.list(),
			fetchProfile(),
		]);
		navigate("/dashboard");
	};

	return (
		<div
			{...rest}
			className={cn("flex flex-col flex-1 gap-4 w-full", className)}
		>
			<div className="absolute left-0 right-0 flex justify-between">
				<Confetti
					config={{
						colors: [
							"#1aaa9d",
							"#ffffff",
							"#4BB543",
							"#f88c5e",
							"#f9b739",
						],
					}}
					active={showConfetti}
				/>
				<Confetti
					config={{
						colors: [
							"#1aaa9d",
							"#ffffff",
							"#4BB543",
							"#f88c5e",
							"#f9b739",
						],
					}}
					active={showConfetti}
				/>
			</div>

			<div className="w-full flex flex-col gap-4 flex-1 rounded-md mt-8">
				<div className="flex flex-col">
					<motion.div
						initial={{ scale: 0.6, opacity: 0 }}
						animate={{ scale: 1, opacity: 1 }}
						transition={{
							delay: 0.7,
						}}
					>
						<div className="flex flex-col mb-6">
							<p className="font-bold text-xl mb-2">
								{t(`${taskType}.title`)}
							</p>
							<p>{t(`${taskType}.description`)}</p>
						</div>
						<Button
							onClick={handleSubmit}
							loading={isLoading}
							className="w-full"
							type="primary"
						>
							{t("continue")}
						</Button>
					</motion.div>
				</div>
			</div>
		</div>
	);
};

export default withTranslation(Completed);
